export default __webpack_public_path__ + "images/hourglass-1.84eac08540bd5a05a56628e8ac2de5cf.png";